<script setup></script>

<template>
    <Link
        :href="route('login')"
        aria-label="Přejít na domovskou stránku"
    >
        <img
            class="h-auto w-24 rounded-lg"
            src="/images/logo.png"
            alt="BrainCode s.r.o."
        />
    </Link>
</template>
